import i18n from '../i18n'

export const GetEnumTranslation = (enumName: string, enumKey: string) => {
  return i18n.t(`Enums.${enumName}.${enumKey}`)
}
